import styled from '@emotion/styled';
import React from 'react';
import { DataFieldWithLabel } from './DataFieldWithLabel';

export type DataGridItem = {
  label: React.ReactNode;
  d: React.ReactNode;
};

const Container = styled('div')((p) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flexWrap: 'wrap',

  gap: p.theme.spacing(8)
}));

export const DataGrid = ({
  ds,
  emptyDefault = null
}: {
  ds: DataGridItem[];
  emptyDefault?: React.ReactNode;
}) => {
  return (
    <Container>
      {ds.map((d, i) => (
        <DataFieldWithLabel key={i} label={d.label}>
          {d.d || emptyDefault}
        </DataFieldWithLabel>
      ))}
    </Container>
  );
};

const VLabel = styled('div')((p) => ({
  color: p.theme.custom.colors.gray.w500
}));

const VerticalContainer = styled('div')((p) => ({
  display: 'grid',
  gridTemplateColumns: 'max-content 1fr',
  gridColumnGap: p.theme.spacing(2),
  gridRowGap: p.theme.spacing(1)
}));

const RowWrapper = styled('div')((p) => ({
  display: 'contents'
}));

export const DataGridVertical = ({
  ds,
  emptyDefault = null,
  headers
}: {
  ds: DataGridItem[];
  emptyDefault?: React.ReactNode;
  headers?: DataGridItem;
}) => {
  return (
    <VerticalContainer>
      {ds.map((d, i) => (
        <RowWrapper key={i}>
          <VLabel>{d.label}</VLabel>
          <div>{d.d || emptyDefault}</div>
        </RowWrapper>
      ))}
    </VerticalContainer>
  );
};
